import $ from 'jquery'
import ModeAdministration from '@/views/parametres/mode-administration'
import ExcelModal from '@/views/parametres/import-excel-modal'
import ListesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

export default {
    name: 'tarif-actes',
    components: {
        ModeAdministration, ExcelModal
    },
    props: [],
    data() {
        return {
            soins_fields: [
				'libelle', 'acte', 'prix', 'actions'
			],

            acte_fields: [
				'libelle', 'prix', 'actions'
			],

            // Actes : pagination et recherche (libellé, abréviation) côté serveur (15/10/2026)
            actes: nouvelleListe(),

            modal_title: '',

            acte_data: {
                type_acte: '',
                id: 0,
                acte: '',
                prix: ''
            },

            soin_data: {
                id: 0,
                libelle: '',
                acte: '',
            },

            btn_disable: false,
            save_loading: false,

            // >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
            del_disable: false,

            type_del: '',

            // Impression : liste complète (actes ou soins) chargée au clic
            is_printing_acte: false,
            a_imprimer: [],
            filename: '',
            is_soin: true,

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix'
            },

            // Export Excel : données construites au clic à partir de la liste complète des actes
            export_en_cours: false,
            export_filename: 'Liste_Acte.xls',
            can_print: false,
            acte_loading_percentage: 0,
            can_view_percentage: false,
            acte_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
            // Rafraîchissement après import : un seul actif à la fois
            jeton_rafraichissement: 0,
        }
    },

    computed: {
        // Options du choix d'acte de la fenêtre « soin » (liste complète chargée à son ouverture)
        tarif_actes() {
            return this.$store.getters["tarif_actes"];
        },
    },
    mounted() {
        // Première page des actes (les soins et autres actes ne servaient qu'à l'impression : chargés au clic)
        this.chargerActes()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_acte_soins_'+tmpstamp
    },

    beforeDestroy() {
        // Arrête un éventuel rafraîchissement après import en cours
        this.jeton_rafraichissement++

        if (this.acte_refresh_timeout_id) {
            clearTimeout(this.acte_refresh_timeout_id)
            this.acte_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }

        clearTimeout(this.actes.minuteur)
    },

    methods: {
        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListActe'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        countdownLoad() {
            const TOTAL_SECONDS = 4 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.acte_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.acte_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.acte_loading_percentage = 0
                }
            }, 1000)
        },

        /**
         * Après un import : recharge la page courante, puis recommence toutes les 5 s tant que la liste reste vide
         * (au plus pendant le compte à rebours de countdownLoad)
         */
        refreshListeActe() {
            if (this.acte_refresh_timeout_id) {
                clearTimeout(this.acte_refresh_timeout_id)
                this.acte_refresh_timeout_id = null
            }

            const jeton = ++this.jeton_rafraichissement
            this.can_view_percentage = true

            this.chargerActes().then(() => {
                // Écran quitté ou autre import terminé entre-temps
                if (jeton !== this.jeton_rafraichissement) {
                    return
                }

                if (this.actes.total > 0 || this.countdown_seconds_left == 0) {
                    this.can_view_percentage = false
                    if (this.countdown_interval_id) {
                        clearInterval(this.countdown_interval_id)
                        this.countdown_interval_id = null
                    }
                    return
                }

                this.acte_refresh_timeout_id = setTimeout(() => {
                    this.refreshListeActe()
                }, 5000)
            })
        },

        loadEmitAction() {
            this.countdownLoad()
            this.refreshListeActe()
        },

        /**
         * Charge la page courante des actes
         */
        chargerActes() {
            const liste = this.actes
            const appel = params => ListesPaginees.actes('acte', params)

            return chargerPage(liste, appel).then(() => {
                // Page devenue vide (ex. suppression du dernier acte de la dernière page) : retour à la dernière page
                if (!liste.chargement && !liste.erreur && liste.lignes.length === 0 && liste.page > 1 && liste.total > 0) {
                    liste.page = Math.ceil(liste.total / liste.per_page)
                    return chargerPage(liste, appel)
                }
            })
        },

        /**
         * Recherche serveur (libellé, abréviation) après la fin de la saisie
         */
        rechercherActes() {
            rechercherDiffere(this.actes, this.chargerActes)
        },

        /**
         * Le tableau (recherche, pagination) reste affiché pendant les rechargements ; il est remplacé par le
         * message « Aucune donnée » seulement si la liste est vide sans recherche
         */
        aDesActes() {
            return this.actes.total > 0 || this.actes.q !== ''
        },

        addActe(type_acte) {
            this.modal_title = "Nouvel acte"

            this.acte_data = {
                type_acte: '',
                id: 0,
                acte: '',
                prix: ''
            }
            this.$refs.observer.reset();

            this.acte_data.type_acte = type_acte
        },

        editActe(data) {
            this.modal_title = data.acte

            this.acte_data = {
                type_acte: data.type_acte,
                id: data.id,
                acte: data.acte,
                prix: data.prix
            }
        },

        /**
         * Liste complète des actes pour le choix d'acte de la fenêtre « soin »
         */
        chargerActesSoin() {
            this.$store.dispatch('getTarifActes', 'acte').catch(() => {})
        },

        editSoin(data) {
            this.modal_title = data.libelle
            this.chargerActesSoin()

            this.soin_data = {
                id: data.id,
                libelle: data.libelle,
                acte: {
                    id: data.acte_id,
                    acte: data.acte
                },
            }
        },

        addSoin() {
            this.modal_title = "Nouveau soin"
            this.chargerActesSoin()

            this.soin_data = {
                id: 0,
                libelle: '',
                acte: '',
            }
            this.$refs.observer.reset();
        },

        async submitActe() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch('saveActe', this.acte_data).then((response) => {
                if (response > 0) {
                    if (this.acte_data.id == 0) {
                        this.successMsg('Acte ajouté avec succès')
                    } else {
                        this.successMsg('Acte modifié avec succès')
                    }


                    // Seuls les actes sont affichés ici : on recharge leur page courante
                    if (this.acte_data.type_acte == 'acte') {
                        this.chargerActes()
                    }

                    this.acte_data = {
                        type_acte: '',
                        id: 0,
                        acte: '',
                        prix: ''
                    }
                    this.$refs.observer.reset();

                    $('.modal').modal('hide')

                }

                this.save_loading = false
                this.btn_disable = false
            })
        },

        async submitSoin() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch('saveSoin', this.soin_data).then((response) => {
                if (response > 0) {
                    this.soin_data = {
                        id: 0,
                        libelle: '',
                        acte: '',
                    }
                    this.$refs.observer.reset();
                    $('.modal').modal('hide')

                    if (this.soin_data.id == 0) {
                        this.successMsg('Soin ajouté avec succès')
                    } else {
                        this.successMsg('Soin modifié avec succès')
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data
		 */
		remove(data, type) {
            this.type_del = type

			if (type == 'acte') {
                this.tarif_to_be_deleted = {
                    id: data.id,
                    libelle: data.acte,
                    type: data.type_acte,
                }
            } else {
                this.tarif_to_be_deleted = {
                    id: data.id,
                    libelle: data.libelle,
                    type: '',
                }
            }

		},

        /**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true
            this.del_disable = true
            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false
                this.del_disable = false
            }

            if (err == 0) {
                if (this.type_del == 'acte') {
                    this.$store.dispatch('deleteActe', this.tarif_to_be_deleted).then((response) => {

                        if (response > 0) {
                            this.successMsg('Acte supprimé avec succès')

                            // Seuls les actes sont affichés ici : on recharge leur page courante
                            if (this.tarif_to_be_deleted.type == 'acte') {
                                this.chargerActes()
                            }
                        }

                        $('.modal').modal('hide')
                        this.del_loading = false;
                        this.is_confirm = false
                        this.del_disable = false
                    })
                } else {
                    this.$store.dispatch('deleteSoin', this.tarif_to_be_deleted).then((response) => {

                        if (response > 0) {
                            this.successMsg('Soin supprimé avec succès')
                        }

                        $('.modal').modal('hide')
                        this.del_loading = false;
                        this.is_confirm = false
                        this.del_disable = false
                    })
                }
            }
        },

        /**
         * Impression : charge la liste complète (soins ou actes) puis imprime toutes les lignes
         * @param {Boolean} v true => soins | false => actes
         */
        printSoinActe(v) {
            if (this.is_printing_acte) {
                return
            }

            this.is_printing_acte = true
            const chargement = v ? this.$store.dispatch('getTarifSoins') : this.$store.dispatch('getTarifActes', 'acte')

            chargement.then((liste) => {
                this.a_imprimer = liste || []
                this.is_soin = v

                this.can_print = true
                setTimeout(() => {
                    window.print()

                    this.can_print = false
                    this.a_imprimer = []
                    this.is_printing_acte = false
                }, 500);
            }).catch(() => {
                this.is_printing_acte = false
                this.errorToast("Impossible de charger la liste à imprimer. Veuillez réessayer.")
            })
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Acte_'+d.getMilliseconds()+'.xls'
        },

        /**
         * Données de l'export Excel, construites au clic à partir de la liste complète des actes
         * (appelé par la prop `fetch` de export-excel ; un tableau vide annule le téléchargement)
         */
        exporterActes() {
            if (this.export_en_cours) {
                return Promise.resolve([])
            }

            this.export_en_cours = true
            return this.$store.dispatch('getTarifActes', 'acte').then(liste => (liste || []).map(tarif_acte => ({
                'libelle' : tarif_acte.acte,
                'prix' : (tarif_acte.prix > 0)?tarif_acte.prix:''
            }))).catch(() => {
                this.errorToast("Impossible de charger la liste à exporter. Veuillez réessayer.")
                return []
            }).finally(() => {
                this.export_en_cours = false
            })
        },
    }
}


